import React, {useState} from 'react'

const OrderForm = ({orderSubmit}) => {
  const
    [name, setName] = useState(''),
    [tel, setTel] = useState(''),
    [email, setEmail] = useState(''),
    [address, setAddress] = useState(''),
    [paid, setPaid] = useState();

  const isFormValid = name && tel && email && address && paid;

  const handleInputChange = event => {
    const targetId = event.target.id;
    const {value} = event.target;

    if (targetId === 'order-name') {
      setName(value.replace(/[^a-zа-я]+$/i, ''))
    } else if (targetId === 'order-tel') {
      setTel(value.replace(/[^\d()-]+$/i, ''))
    } else if (targetId === 'order-email') {
      setEmail(value.replace(/[^\w-@.]+$/, ''))
    } else if (targetId === 'order-address') {
      setAddress(value)
    }
  };

  const handleRadioChange = event => {
    const {value} = event.target;
    const {textContent} = event.target.nextSibling;
    let newPaid;

    if (value === 'card-online') {
      newPaid = {
        type: 'onlineCard',
        title: textContent
      }
    } else if (value === 'card-courier') {
      newPaid = {
        type: 'offlineCard',
        title: textContent
      }
    } else if (value === 'cash') {
      newPaid = {
        type: 'offlineCash',
        title: textContent
      }
    }

    setPaid(newPaid)
  };

  const handleSubmit = event => {
    event.preventDefault();

    if (isFormValid) {
      orderSubmit(name, tel, email, address, paid)
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="order-process__delivery">
        <h3 className="h3">кому и куда доставить?</h3>
        <div className="order-process__delivery-form">
          <label className="order-process__delivery-label">
            <div className="order-process__delivery-text">Имя</div>
            <input className="order-process__delivery-input" id="order-name" type="text" name="delivery"
                   placeholder="Представьтесь, пожалуйста" autoComplete="shipping name"
                   value={name} onChange={handleInputChange}/>
          </label>
          <label className="order-process__delivery-label">
            <div className="order-process__delivery-text">Телефон</div>
            <input className="order-process__delivery-input" id="order-tel" type="tel" name="delivery"
                   placeholder="Номер в любом формате" autoComplete="shipping tel"
                   value={tel} onChange={handleInputChange}/>
          </label>
          <label className="order-process__delivery-label">
            <div className="order-process__delivery-text">E-mail</div>
            <input className="order-process__delivery-input" id="order-email" type="email" name="delivery"
                   placeholder="Укажите E-mail" autoComplete="shipping email"
                   value={email} onChange={handleInputChange}/>
          </label>
          <label className="order-process__delivery-label order-process__delivery-label_adress">
            <div className="order-process__delivery-text">Адрес</div>
            <input className="order-process__delivery-input order-process__delivery-input_adress" id="order-address"
                   type="text" name="delivery"
                   placeholder="Ваша покупка будет доставлена по этому адресу"  autoComplete="shipping address"
                   value={address} onChange={handleInputChange}/>
          </label>
        </div>
        <p>Все поля обязательны для заполнения. Наш оператор свяжется с вами для уточнения деталей заказа.</p>
      </div>
      <div className="order-process__paid">
        <h3 className="h3">хотите оплатить онлайн или курьеру при получении?</h3>
        <div className="order-process__paid-form" onChange={handleRadioChange}>
          <label className="order-process__paid-label">
            <input className="order-process__paid-radio" type="radio" name="paid" value="card-online"/>
            <span className="order-process__paid-text">Картой онлайн</span>
          </label>
          <label className="order-process__paid-label">
            <input className="order-process__paid-radio" type="radio" name="paid" value="card-courier"/>
            <span className="order-process__paid-text">Картой курьеру</span>
          </label>
          <label className="order-process__paid-label">
            <input className="order-process__paid-radio" type="radio" name="paid" value="cash"/>
            <span className="order-process__paid-text">Наличными курьеру</span>
          </label>
        </div>
      </div>
      <button
        className={`order-process__form-submit order-process__form-submit_click ${isFormValid ?
          '' : 'order-process__form-submit_disabled'}`}>
        Подтвердить заказ
      </button>
    </form>
  )
};

export default OrderForm
